import { useLayoutEffect } from 'react';
import { OverlayScrollbars } from 'overlayscrollbars';
import { OS_SCROLL_OPTIONS } from '../ui/OsScroll';

/**
 * OverlayScrollbars for the scrollable blocks inside AI chat markdown — code
 * blocks and tables — which is injected HTML (dangerouslySetInnerHTML), so the
 * React <OsScroll> cannot wrap it (owner, 30.09.2026: a long SQL block showed
 * the grey native horizontal bar).
 *
 * Runs once the message has finished streaming: while it streams, the HTML is
 * replaced on every token, so instances would be torn down and rebuilt each
 * time — the CSS hides the native bar meanwhile. Tables are wrapped in a div
 * here (a <table> cannot host the scroller, and the sanitizer strips classes
 * from markdown-made divs). Everything is destroyed on cleanup.
 */
export default function useOverlayScrollBlocks(ref, html, enabled) {
  useLayoutEffect(() => {
    const root = ref.current;
    if (!root || !enabled) return undefined;
    const instances = [];
    root.querySelectorAll('pre').forEach((pre) => {
      instances.push(OverlayScrollbars(pre, OS_SCROLL_OPTIONS));
    });
    root.querySelectorAll('table').forEach((table) => {
      let host = table.parentElement;
      if (!host || !host.classList.contains('ai-chat-table-scroll')) {
        host = document.createElement('div');
        host.className = 'ai-chat-table-scroll';
        table.parentNode.insertBefore(host, table);
        host.appendChild(table);
      }
      instances.push(OverlayScrollbars(host, OS_SCROLL_OPTIONS));
    });
    return () => instances.forEach((i) => i.destroy());
  }, [ref, html, enabled]);
}
